import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { AlertWithIcon } from './ui/alert'

interface ErrorProps {
  children: ReactNode
  wrapped?: boolean
  // "use the link in your email" only makes sense to patients
  patientHint?: boolean
}

export function Error({
  children,
  wrapped = true,
  patientHint = false
}: ErrorProps) {
  const { t } = useTranslation()
  return (
    <AlertWithIcon
      variant="destructive"
      title={
        wrapped
          ? String(t('error.title', { defaultValue: 'Error' }))
          : undefined
      }
    >
      <div className="space-y-2">
        <p>{children}</p>
        {wrapped && patientHint && (
          <p>
            {t('error.general', { defaultValue: 'Please try again later.' })}
          </p>
        )}
      </div>
    </AlertWithIcon>
  )
}
